import {IDateTimeWithZone} from './date-time-with-zone.interface';

export class DateTimeWithZone implements IDateTimeWithZone {
  constructor(iDateTimeWithZone?: IDateTimeWithZone) {
    if(iDateTimeWithZone?.dateTime === '') {
      this.dateTime = null;
    }
    this.dateTime = iDateTimeWithZone?.dateTime || null;
    this.timeZone = iDateTimeWithZone?.timeZone;
  }

  dateTime: string;
  timeZone: string;
}
